import React from 'react';
import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import PageNotFound from '@/creditflowresearch/ui/common/components/PageNotFoundWrp';

const CompanyPage = () => (
  <PageContentLayout>
    <PageNotFound />
  </PageContentLayout>
);

export default CompanyPage;
